/**
 * 說明 : 機器資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增機器資訊
export const addMachine = createAsyncThunk(
  'customer/addMachine',
  async (machine, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/machine', machine, token);
      return data;
    } catch (err) {
      console.error('add machine error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改機器資訊
export const editMachine = createAsyncThunk(
  'customer/editMachine',
  async ({id, ...machine}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(`/machine/${id}`, machine, token);
      return data;
    } catch (err) {
      console.error('edit machine error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const bulkEditMachines = createAsyncThunk(
  'customer/bulkEditMachine',
  async ({ids, options}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(`/machine`, {ids, options}, token);
      return data;
    } catch (err) {
      console.error('edit machine error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得機器資料
export const fetchMachine = createAsyncThunk(
  'machine/fetchMachine',
  async ({id}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(`/machine/${id}`, null, token);
      return data;
    } catch (err) {
      console.error('fetch elevator error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得機器清單列表
export const fetchMachineList = createAsyncThunk(
  'machine/fetchMachineList',
  async (
    {
      deliveryCode,
      machineSerialNumber,
      machineTypeId,
      withAssignment,
      orderBy,
      dir,
      limit = 0,
      page = 0,
      isNeedToOrder = false,
    },
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/machine',
        {
          deliveryCode,
          machineSerialNumber,
          machineTypeId,
          withAssignment,
          orderBy,
          dir,
          limit,
          page,
          isNeedToOrder,
        },
        token,
      );
      return data;
    } catch (err) {
      //   console.error('fetch elevator list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的機器名稱選單
export const fetchMachineSelection = createAsyncThunk(
  'customer/fetchMachineSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/customer',
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch customer selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchMachineAssignmentHistory = createAsyncThunk(
  'machine/fetchAssignmentHistory',
  async ({id, type}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      return await BaseAPI.getWithAuth(
        `machine/${id}/assignmentHistories`,
        {type},
        token,
      );
    } catch (error) {
      console.error('fetch customer selection error', error.response.data);
      return rejectWithValue(error.response.data);
    }
  },
);
